module.exports = __webpack_public_path__ + "img/组 18-7.eadc05f8.png";